import React, { useEffect, useState } from "react";

import { FilterOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { getRotoPaginationListNew } from "services/redux/Roto/action";
import { getRotoTenderBasicPagination } from "services/redux/officeresource/business/action";
import RotoFilter from "../RotoMain/RotoFilter";
import { Tabs, Collapse, Button } from "antd";
import RotoOnlyTemplateViewTable from "./Roto";
import DynamicCircularTemplate from "./DynamicCircularTemplate/index";
import RotoTender from "./Tender";
import RotoCompanyTemplateViewTable from "./Company";
import { getRotoCompanyPaginationListNew } from "services/redux/Roto/rotoCompany/action";

const { TabPane } = Tabs;
const { Panel } = Collapse;

const SimilarRotoTender = () => {
  const { getRotoListingLoading } = useSelector((state) => state.rotoReducer);
  const { sowDetailsLoading } = useSelector((state) => state.businessCenter);
  const [isCollapsed, setIsCollapsed] = useState(true); // Set to true for closed by default
  const { getRotoCompanyListingLoading } = useSelector(
    (state) => state.rotoCompanyReducer
  );
  const [filterModal, setFilterModal] = useState({
    visible: false,
    loading: false,
  });
  const [filterData, setFilterData] = useState();
  const [selectedTabPaneKey, setTabPaneKey] = useState("1");
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const dispatch = useDispatch();
  const pageSize = 30;

  const initialValue = {
    skipCount: 0,
    maxResultCount: pageSize,
  };

  useEffect(() => {
    if (
      !sowDetailsLoading &&
      !getRotoListingLoading &&
      !getRotoCompanyListingLoading
    ) {
      setFilterModal({
        visible: false,
        loading: false,
      });
    }
  }, [sowDetailsLoading, getRotoListingLoading, getRotoCompanyListingLoading]);

  const advancedSearch = (values) => {
    setFilterModal({
      ...filterModal,
      loading: true,
    });

    const newValues = {
      // SearchKeyword: values.SearchKeyword ?? "",
      // ScopeOfWorks: values.SearchKeyword ?? "",
      ...values,
      // searchDateFrom: startDate ?? "",
      // searchDateTo: endDate ?? "",
      tenderTypes: values.tenderTypes && [values.tenderTypes],
      sectorTypes: values.sectorTypes && [values.sectorTypes],
      skipCount: 0,
      maxResultCount: pageSize,
    };

    setFilterData(newValues);

    if (selectedTabPaneKey === "1") {
      dispatch(getRotoTenderBasicPagination(newValues));
    } else if (selectedTabPaneKey === "2") {
      dispatch(getRotoPaginationListNew(newValues));
    } else if (selectedTabPaneKey === "3") {
      dispatch(getRotoCompanyPaginationListNew(newValues));
    }
  };

  const handleTabChange = (key) => {
    setTabPaneKey(key);
  };

  useEffect(() => {
    if (selectedTabPaneKey === "1") {
      dispatch(
        getRotoTenderBasicPagination(
          filterData !== undefined ? filterData : initialValue,
          false
        )
      );
    } else if (selectedTabPaneKey === "2") {
      dispatch(
        getRotoPaginationListNew(
          filterData !== undefined ? filterData : initialValue,
          false
        )
      );
    } else if (selectedTabPaneKey === "3") {
      dispatch(
        getRotoCompanyPaginationListNew(
          filterData !== undefined ? filterData : initialValue,
          false
        )
      );
    }
  }, [selectedTabPaneKey]);

  return (
    <>
      <div className="organizer__list todo__list">
        <div style={{ display: "flex", justifyContent: "end" }}>
          <span
            className="side__search__wrapper side-contact-search-filter"
            style={{
              cursor: "pointer",
              height: "25px",
              marginTop: "5 px",
            }}
            onClick={() => {
              setFilterModal({
                visible: true,
                loading: false,
              });
            }}
          >
            <FilterOutlined />
          </span>
        </div>
      </div>
      <div style={{ display: "flex" }}>
        {/* Left Side Tabs */}
        <div style={{ flex: 1 }}>
          <Tabs
            className="global-tabs-wrapper referencetabs"
            defaultActiveKey="1"
            size="large"
            activeKey={selectedTabPaneKey}
            onChange={handleTabChange}
          >
            <TabPane className={"summary-wrapper"} tab="Tender" key="1">
              <RotoTender filterData={filterData} />
            </TabPane>

            <TabPane tab="RotoOnly" key="2" className={"summary-wrapper"}>
              <RotoOnlyTemplateViewTable filterData={filterData} />
            </TabPane>

            <TabPane tab="Company" key="3" className={"summary-wrapper"}>
              <RotoCompanyTemplateViewTable
                filterData={filterData}
                selectedTemplate={selectedTemplate}
              />
            </TabPane>
          </Tabs>
        </div>

        {/* Collapsible Right Side */}
        <div
          style={{
            width: isCollapsed ? "50px" : "600px",
            transition: "width 0.3s",
            overflow: "hidden",
          }}
        >
          <Button
            onClick={() => setIsCollapsed(!isCollapsed)}
            style={{ marginBottom: 10 }}
          >
            {isCollapsed ? "←" : "→"}
          </Button>
          {!isCollapsed && (
            <DynamicCircularTemplate
              selectedTemplate={selectedTemplate}
              setSelectedTemplate={setSelectedTemplate}
            />
          )}
        </div>
      </div>

      <RotoFilter
        title={"Filter"}
        filterModal={filterModal}
        setFilterModal={setFilterModal}
        advancedSearch={advancedSearch}
      />
    </>
  );
};

export default SimilarRotoTender;
